var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_373_2065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7551 0.5H0V24.5H23.7551V0.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_373_2065)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_373_2065",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.529541H23.7259V24.5001H0V0.529541Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_373_2065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2788 11.4474L12.9195 0.982056C12.7776 0.83857 12.6091 0.724798 12.4237 0.647141C12.2382 0.569484 12.0394 0.529541 11.8387 0.529541C11.6379 0.529541 11.4391 0.569484 11.2537 0.647141C11.0682 0.724798 10.8997 0.83857 10.7578 0.982056L8.60746 3.1556L11.3357 5.91194C11.6564 5.80188 12.0013 5.78474 12.3312 5.86234C12.6611 5.94 12.9629 6.10937 13.2025 6.35126C13.4434 6.59491 13.6116 6.90217 13.6878 7.23788C13.7641 7.5736 13.7452 7.92423 13.6335 8.2496L16.2638 10.9063C16.586 10.7933 16.9332 10.7742 17.2655 10.8514C17.5979 10.9285 17.902 11.0987 18.143 11.3425C18.3119 11.513 18.4458 11.7155 18.5372 11.9383C18.6285 12.1612 18.6756 12.4 18.6756 12.6412C18.6756 12.8824 18.6285 13.1213 18.5372 13.3441C18.4458 13.567 18.3119 13.7694 18.143 13.9399C17.8018 14.2845 17.339 14.4779 16.8565 14.4779C16.3741 14.4779 15.9114 14.2845 15.57 13.9399C15.3165 13.6834 15.1437 13.3567 15.0735 13.0011C15.0033 12.6455 15.0388 12.277 15.1755 11.9417L12.7225 9.46423V15.9852C12.9814 16.1144 13.2061 16.3041 13.378 16.5385C13.5499 16.7729 13.6641 17.0454 13.711 17.3332C13.758 17.6211 13.7364 17.9161 13.648 18.1939C13.5596 18.4716 13.4069 18.7241 13.2028 18.9304C13.034 19.101 12.8335 19.2363 12.613 19.3286C12.3924 19.4209 12.156 19.4684 11.9173 19.4684C11.6785 19.4684 11.4421 19.4209 11.2216 19.3286C11.001 19.2363 10.8006 19.101 10.6318 18.9304C10.4629 18.7598 10.329 18.5574 10.2376 18.3345C10.1462 18.1117 10.0991 17.8727 10.0991 17.6315C10.0991 17.3903 10.1462 17.1514 10.2376 16.9286C10.329 16.7057 10.4629 16.5032 10.6318 16.3326C10.8019 16.1605 11.0041 16.024 11.2267 15.9312V9.35023C11.005 9.25794 10.8036 9.12234 10.6339 8.9512C10.4642 8.78006 10.3297 8.57674 10.238 8.35286C10.1464 8.12903 10.0994 7.88914 10.0998 7.64686C10.1002 7.40463 10.148 7.16486 10.2403 6.94137L7.55036 4.22308L0.446561 11.3983C0.160255 11.6881 -0.000488281 12.0807 -0.000488281 12.4902C-0.000488281 12.8996 0.160255 13.2923 0.446561 13.5821L10.8063 24.0486C11.0931 24.3378 11.4818 24.5002 11.887 24.5002C12.2921 24.5002 12.6807 24.3378 12.9675 24.0486L23.2788 13.6311C23.5651 13.3413 23.7258 12.9486 23.7258 12.5392C23.7258 12.1298 23.5651 11.7371 23.2788 11.4474Z",
    fill: "#F03C2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.bf3a8123cdfa594db0c8290c7ad30665.svg";
export { ForwardRef as ReactComponent };